import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http, getGuestId } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    http.get("/auth/me").then((r) => setUser(r.data))
      .catch(() => http.post("/auth/refresh").then((r) => setUser(r.data)).catch(() => setUser(false)));
  }, []);

  useEffect(() => {
    if (user === null) return;
    const key = `ping-${user ? "u" : "g"}-${new Date().toLocaleDateString("en-CA", { timeZone: "Australia/Sydney" })}`;
    if (localStorage.getItem(key)) return;
    http.post("/ping").then(() => localStorage.setItem(key, "1")).catch(() => {});
  }, [user]);

  const login = useCallback(async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password, guest_id: getGuestId() });
    setUser(data);
    return data;
  }, []);

  const register = useCallback(async (name, email, password) => {
    const { data } = await http.post("/auth/register", { name, email, password, guest_id: getGuestId() });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    await http.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
